import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import {
  GetPatientSensorsAverageDataFilter,
  PatientFilter,
  PatientFilterFormatted,
  UpdateStatusShape,
  GetPatientDetailedSensorsDataFilter,
} from "@shared/interfaces";

import { CreatePatientDto, ImportPatientsDto } from "../interfaces";

export default {
  getPatients: (payload: PatientFilter) => {
    const { hospital, assigned_user, search, ...restParams } = payload;

    const params: PatientFilterFormatted = {
      ...restParams,
      search: search?.trim(),
    };

    if (assigned_user) {
      params.assigned_user_id = Number(assigned_user.value);
    }

    if (hospital) {
      params.hospital_id = Number(hospital.value);
    }

    return request(METHODS.GET, API.PATIENT.GET_PATIENTS)({ params });
  },
  importPatients: (payload: ImportPatientsDto) => request(METHODS.POST, API.PATIENT.IMPORT_PATIENTS)(payload),
  createPatient: (payload: CreatePatientDto) => request(METHODS.POST, API.PATIENT.CREATE_PATIENT)(payload),
  updatePatient: (payload: CreatePatientDto & { id: number }) => {
    const { id, ...rest } = payload;
    return request(METHODS.PUT, API.PATIENT.UPDATE_PATIENT(String(id)))(rest);
  },
  updatePatientStatus: (payload: UpdateStatusShape) => {
    const { id, status, reason } = payload;
    return request(METHODS.PUT, API.PATIENT.UPDATE_PATIENT_STATUS(String(id)))({ status, reason });
  },
  getPatient: (payload: { id: number }) => {
    const { id } = payload;
    return request(METHODS.GET, API.PATIENT.GET_PATIENT(String(id)))();
  },
  getPatientSensorsAverageData: (patientId: number, params: GetPatientSensorsAverageDataFilter) =>
    request(METHODS.GET, API.PATIENT.GET_PATIENT_SENSORS_AVERAGE_DATA(String(patientId)))({ params }),
  getPatientDetailedSensorsData: (patientId: number, params: GetPatientDetailedSensorsDataFilter) =>
    request(METHODS.GET, API.PATIENT.GET_PATIENT_DETAILED_SENSORS_DATA(String(patientId)))({ params }),
};
